import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import {
    START_QUERY_GROUP_DIRSH,
    QUERY_GROUP_DIRSH_SUCCESS,
    QUERY_GROUP_DIRSH_FAILURE,
    INIT_QUERY_GROUP_DIRSH_ACTION_STATUS,
    GROUP_DIRSH_QUERY_CHANGE_INPUT,
    SELECT_GROUP_DIRSH,
    OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
    RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
    ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT,
    START_SUBMIT_ADD_GROUP_DIRSH,
    SUBMIT_ADD_GROUP_DIRSH_SUCCESS,
    SUBMIT_ADD_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS,
    START_SUBMIT_UPDATE_GROUP_DIRSH,
    SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS,
    SUBMIT_UPDATE_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS,
    OPEN_DEL_GROUP_DIRSH_MODAL,
    RESET_DEL_GROUP_DIRSH_MODAL,
    START_SUBMIT_DEL_GROUP_DIRSH,
    SUBMIT_DEL_GROUP_DIRSH_SUCCESS,
    SUBMIT_DEL_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS,
} from './GroupDirShConstants';

const CURRENT_END_DATE = '9999-12-31';

const initialModalFields = {
    id: undefined,
    entityNameEng: undefined,
    entityNameOther: undefined,
    incorpNo: undefined,
    entityCode: undefined,
    incorpPlace: undefined,
    position: undefined,
    holdingPct: undefined,
    legalNameEng: undefined,
    legalNameOther: undefined,
    effectiveDate: undefined,
    endDate: undefined,
    remarks: undefined,
    lastUpdatedBy: undefined,
    lastUpdateTime: undefined,
};

const initialState = {
    queryFields: {
        entityNameEng: undefined,
        position: undefined,
        legalNameEng: undefined,
        currentStatus: 'Current',
    },
    selectedGroupDirShArray: [],
    groupDirShModal: {
        isOpened: false,
        mode: 'ADD',
        respErrMsg: '',
        fields: initialModalFields,
    },
    delGroupDirShModal: {
        isOpened: false,
        respErrMsg: '',
        fields: {
            id: undefined,
        },
    },
};

function startQueryGroupDIRSH(state) {
    return {
        ...state,
        queryGroupDirShStatus: ACTION_STATUS.LOGINING,
    };
}

function queryGroupDIRSHSuccess(state, resp) {
    return {
        ...state,
        queryGroupDirShStatus: ACTION_STATUS.SUCCESS,
        queryGroupDirShResp: resp,
    };
}

function queryGroupDIRSHFailure(state, err) {
    return {
        ...state,
        queryGroupDirShStatus: ACTION_STATUS.ERROR,
        queryGroupDirShResp: err,
    };
}

function initQueryGroupDIRSHActionStatus(state) {
    return {
        ...state,
        queryGroupDirShStatus: ACTION_STATUS.READY,
        selectedGroupDirShArray: [],
    };
}

function groupDIRSHQueryChangeInput(state, { name, value }) {
    return {
        ...state,
        queryFields: {
            ...state.queryFields,
            [name]: value,
        },
    };
}

function selectGroupDIRSH(state, array) {
    return {
        ...state,
        selectedGroupDirShArray: array,
    };
}

function openAddOrEditGroupDIRSHModal(state, { mode, data }) {
    if (mode === 'ADD' || !data) {
        return {
            ...state,
            groupDirShModal: {
                ...initialState.groupDirShModal,
                isOpened: true,
                mode: 'ADD',
                fields: initialModalFields,
            },
        };
    }
    const rawEndDate = data.endDate || CURRENT_END_DATE;
    const isCurrentEndDate = rawEndDate === CURRENT_END_DATE || rawEndDate === 'Current';
    return {
        ...state,
        groupDirShModal: {
            ...initialState.groupDirShModal,
            isOpened: true,
            mode: 'EDIT',
            fields: {
                ...initialModalFields,
                id: data.id,
                entityNameEng: data.entityNameEng,
                entityNameOther: data.entityNameOther,
                incorpNo: data.incorpNo,
                entityCode: data.entityCode,
                incorpPlace: data.incorpPlace,
                position: data.position,
                holdingPct: data.holdingPct,
                legalNameEng: data.legalNameEng,
                legalNameOther: data.legalNameOther,
                effectiveDate: data.effectiveDate,
                endDate: isCurrentEndDate ? undefined : data.endDate,
                remarks: data.remarks,
                lastUpdatedBy: data.lastUpdatedBy,
                lastUpdateTime: data.lastUpdateTime,
            },
        },
    };
}

function resetAddOrEditGroupDIRSHModal(state) {
    return {
        ...state,
        groupDirShModal: initialState.groupDirShModal,
    };
}

function addOrEditGroupDIRSHChangeInput(state, { name, value }) {
    return {
        ...state,
        groupDirShModal: {
            ...state.groupDirShModal,
            fields: {
                ...state.groupDirShModal.fields,
                [name]: value,
            },
        },
    };
}

function startSubmitAddGroupDIRSH(state) {
    return {
        ...state,
        submitAddGroupDirShStatus: ACTION_STATUS.LOGINING,
    };
}

function submitAddGroupDIRSHSuccess(state) {
    return {
        ...state,
        submitAddGroupDirShStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitAddGroupDIRSHFailure(state, err) {
    return {
        ...state,
        submitAddGroupDirShStatus: ACTION_STATUS.ERROR,
        groupDirShModal: {
            ...state.groupDirShModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitAddGroupDIRSHActionStatus(state) {
    return {
        ...state,
        submitAddGroupDirShStatus: ACTION_STATUS.READY,
    };
}

function startSubmitUpdateGroupDIRSH(state) {
    return {
        ...state,
        submitUpdateGroupDirShStatus: ACTION_STATUS.LOGINING,
    };
}

function submitUpdateGroupDIRSHSuccess(state) {
    return {
        ...state,
        submitUpdateGroupDirShStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitUpdateGroupDIRSHFailure(state, err) {
    return {
        ...state,
        submitUpdateGroupDirShStatus: ACTION_STATUS.ERROR,
        groupDirShModal: {
            ...state.groupDirShModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitUpdateGroupDIRSHActionStatus(state) {
    return {
        ...state,
        submitUpdateGroupDirShStatus: ACTION_STATUS.READY,
    };
}

function openDelGroupDIRSHModal(state, data) {
    return {
        ...state,
        delGroupDirShModal: {
            ...initialState.delGroupDirShModal,
            isOpened: true,
            fields: {
                id: data.id,
            },
        },
    };
}

function resetDelGroupDIRSHModal(state) {
    return {
        ...state,
        delGroupDirShModal: initialState.delGroupDirShModal,
    };
}

function startSubmitDelGroupDIRSH(state) {
    return {
        ...state,
        submitDelGroupDirShStatus: ACTION_STATUS.LOGINING,
    };
}

function submitDelGroupDIRSHSuccess(state) {
    return {
        ...state,
        submitDelGroupDirShStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitDelGroupDIRSHFailure(state, err) {
    return {
        ...state,
        submitDelGroupDirShStatus: ACTION_STATUS.ERROR,
        delGroupDirShModal: {
            ...state.delGroupDirShModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitDelGroupDIRSHActionStatus(state) {
    return {
        ...state,
        submitDelGroupDirShStatus: ACTION_STATUS.READY,
    };
}

export default createReducer(initialState, {
    [START_QUERY_GROUP_DIRSH]: startQueryGroupDIRSH,
    [QUERY_GROUP_DIRSH_SUCCESS]: queryGroupDIRSHSuccess,
    [QUERY_GROUP_DIRSH_FAILURE]: queryGroupDIRSHFailure,
    [INIT_QUERY_GROUP_DIRSH_ACTION_STATUS]: initQueryGroupDIRSHActionStatus,
    [GROUP_DIRSH_QUERY_CHANGE_INPUT]: groupDIRSHQueryChangeInput,
    [SELECT_GROUP_DIRSH]: selectGroupDIRSH,
    [OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL]: openAddOrEditGroupDIRSHModal,
    [RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL]: resetAddOrEditGroupDIRSHModal,
    [ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT]: addOrEditGroupDIRSHChangeInput,
    [START_SUBMIT_ADD_GROUP_DIRSH]: startSubmitAddGroupDIRSH,
    [SUBMIT_ADD_GROUP_DIRSH_SUCCESS]: submitAddGroupDIRSHSuccess,
    [SUBMIT_ADD_GROUP_DIRSH_FAILURE]: submitAddGroupDIRSHFailure,
    [INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS]: initSubmitAddGroupDIRSHActionStatus,
    [START_SUBMIT_UPDATE_GROUP_DIRSH]: startSubmitUpdateGroupDIRSH,
    [SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS]: submitUpdateGroupDIRSHSuccess,
    [SUBMIT_UPDATE_GROUP_DIRSH_FAILURE]: submitUpdateGroupDIRSHFailure,
    [INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS]: initSubmitUpdateGroupDIRSHActionStatus,
    [OPEN_DEL_GROUP_DIRSH_MODAL]: openDelGroupDIRSHModal,
    [RESET_DEL_GROUP_DIRSH_MODAL]: resetDelGroupDIRSHModal,
    [START_SUBMIT_DEL_GROUP_DIRSH]: startSubmitDelGroupDIRSH,
    [SUBMIT_DEL_GROUP_DIRSH_SUCCESS]: submitDelGroupDIRSHSuccess,
    [SUBMIT_DEL_GROUP_DIRSH_FAILURE]: submitDelGroupDIRSHFailure,
    [INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS]: initSubmitDelGroupDIRSHActionStatus,
});
